export default "__VITE_ASSET__BMeZ1il$__"